'use client';
import { format } from 'date-fns';
import { useClientHasRendered } from '../../helpers/hooks';
import { Text } from '../Text/Text';
import { TextLoader } from '../Text/TextLoader';
import { twMerge } from 'tailwind-merge';

export const HydrationSafeDate = ({
  className,
  date,
  formatStr = 'MMMM do, yyyy',
  uniqueLoaderKey = 'hydration-safe-date-loader',
}: {
  className?: string;
  date: string;
  formatStr?: string;
  uniqueLoaderKey?: string;
}) => {
  const clientHasRendered = useClientHasRendered();
  const safeDate = clientHasRendered ? format(new Date(date), formatStr) : undefined;

  if (!safeDate) {
    return <TextLoader uniqueKey={uniqueLoaderKey} variant="sm" width={120} />;
  }

  return (
    <Text variant="sm" className={twMerge(className, 'text-midnight mb-0')}>
      {safeDate}
    </Text>
  );
};
